import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.53 4.53a.75.75 0 1 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06l6 6a.75.75 0 1 0 1.06-1.06l-4.72-4.72H16A3.25 3.25 0 0 1 19.25 14v7a.75.75 0 0 0 1.5 0v-7A4.75 4.75 0 0 0 16 9.25H5.81z"
    }, null, -1)
  ])))
}
export default { render: render }